$(function() {
    var dz = $("#dropzonejs").dropzone({
        maxFiles: 1,
        maxFilesize: 15,
        uploadMultiple: false,
        parallelUploads: 1,
        createImageThumbnails: false,
        url: upload_document_url,
        autoProcessQueue: false,
        acceptedFiles: "application/pdf",
        addRemoveLinks: true,
        dictRemoveFile: Lang.get('messages.delete'),
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function (file, response) {
            if(response.success){
                if(response.data.document_id) {
                    addDocument(response.data.code, response.data.model, response.data.model_name, response.data.model_id, response.data.document_id, response.data.path, response.data.description, response.data.date);
                }

                $.toast({
                    text: Lang.get('messages.good_job'),
                    icon: 'success',
                    position: 'bottom-right'
                });

                $('#docsModal').modal('hide');
                resetDocsModalForm();
            }else{
                $.toast({
                    text : Lang.get('messages.unable_to_upload'),
                    icon: 'warning',
                    position : 'bottom-right'
                });
            }
        },
        init: function() {
            this.on("sending", function (file, xhr, formData) {
                $('#uploadFilesForm').find('input, textarea, select').each(function(){
                    if($(this).is(':disabled') === false){
                        formData.append($(this).attr('name'), $(this).val());
                    }
                });
            });

            this.on("maxfilesexceeded", function (file) {
                this.removeAllFiles();
                this.addFile(file);
            });
        },
        error: function(file, errorMessage, xhr){
            $.toast({
                text : errorMessage,
                icon: 'warning',
                position : 'bottom-right',
                allowToastClose : true,
                hideAfter : 60000,
            });
        }
    });


    $('#uploadFilesForm').submit(function(e){
        e.preventDefault();

        if(dz[0].dropzone.files.length < 1){
            $.toast({
                text : Lang.get('messages.attach_your_file_first'),
                icon: 'warning',
                position : 'bottom-right'
            });
        }else{
            dz[0].dropzone.processQueue();
        }

        return false;
    });
});

$(document).on("click", '.file-tree .send-notification > a', function(e){
    e.preventDefault();

    Swal.fire({
        title: 'Segur que vols enviar aquesta sol·licitud?',
        text: "Aquesta acció enviarà una notificació a l\'empresa.",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, envía la sol·licitud!'
    }).then((result) => {
        if (result.isConfirmed) {
            $.post("/ajax/notifications/send", {
                'type': 'circular-spa',
            }, function (json) {
                if(json.success === true){
                    Swal.fire(
                        'Genial',
                        'La notificació ha sigut enviada.',
                        'success'
                    )
                }
            }, 'json');
        }
    })
});

$(document).on("click", '.file-tree .file-upload > a', function(e){
    e.preventDefault();

    var emp_id = $(this).closest('li.file-tree-folder').data('employee');
    var wt_id = $(this).closest('li.file-tree-folder').data('workteam');
    var p_id = $(this).closest('li.file-tree-folder').data('product');
    var code = $(this).closest('li.file-tree-folder.master').data('code');
    var folder_id = $(this).closest('li.file-tree-folder').data('folder');
    var wp_id = $('#wp').val();
    var modal = $('#docsModal');
    var modalForm = $('#uploadFilesForm');
    var title = $.trim($(e.target).closest('li.file-tree-folder.master.open')[0].childNodes[0].textContent).toUpperCase();

    //En el cas de l'arbre de Control de riscos higiènics tenim 2 modals diferents amb aquestes diferències:
    //  => si és es "estudi higiènci" (20201) cal especificar "descripcio"
    //  => si és "fitxa de seguretat" (20202) cal especificar producte (product_id)
    if(code === 20201){
        //estudi higiènic
        modalForm = $('#uploadFilesForm');
    }

    //Mostrar gravetat només en investigació d'accidents (en incidents no)
    if([21101, 21102].indexOf(code) !== false){
        $('#gravetat, #medical_leave').toggle(code === 21101);
    }

    //Mostrar controls que toquen a cada part de l'avaluació de riscos.
    if([20201, 20202, 20203].indexOf(code) !== -1){
        if(code === 20202){ //fitxes de seguretat
            $('#descripcio').find('input').attr('disabled', 'disabled');
            $('#descripcio').hide();
            $('#idl').find('input').attr('disabled', 'disabled');
            $('#idl').hide();
        }else if(code === 20201) { //estudi higiènic
            $('#descripcio').find('input').removeAttr('disabled');
            $('#descripcio').show();
            $('#idl').find('input').attr('disabled', 'disabled');
            $('#idl').hide();
        }else if(code === 20203) { // aut. productes
            $('#descripcio').find('input').removeAttr('disabled');
            $('#descripcio').show();
            $('#idl').find('input').removeAttr('disabled');
            $('#idl').show();
        }
    }

    //Mostrar controls que toquen a Coordinacio activitats empresarials
    if([20801, 20802, 20803, 20804, 20805, 20806].indexOf(code) !== -1){
        if([20805].indexOf(code) !== -1){
            $('#lloc_centre').find('select').removeAttr('disabled');
            $('#lloc_centre').show();
        }else{
            $('#lloc_centre').find('select').attr('disabled', 'disabled');
            $('#lloc_centre').hide();
        }
        if([20801].indexOf(code) !== -1){
            $('#caducitat').find('input').removeAttr('disabled');
            $('#data_caducitat').show();
        }else{
            $('#caducitat').find('input').attr('disabled', 'disabled');
            $('#data_caducitat').hide();
        }
    }

    //Settejar titol
    modal.find('.modal-title').html(title);

    //Emplenar el codi del tipus de fitxer
    modalForm.find('input[name="code"]').val(code);

    //Emplenar la id del centre de treball sel·leccionat
    modalForm.find('input[name="workplace_id"]').val(wp_id);

    //Emplenar la id de l'equip de treball
    modalForm.find('input[name="workteam_id"]').val(wt_id);

    //Emplenar la id del producte
    modalForm.find('input[name="product_id"]').val(p_id);

    //Emplenar la id de treballador
    modalForm.find('input[name="employee_id"]').val(emp_id);

    //Emplenar Carpeta pare
    modalForm.find('input[name="folder_id"]').val(folder_id);

    //Si tenim treballador especificar el lloc de treball
    if(emp_id) {
        var ddLlocCentre = modalForm.find('select[name="id_lloc_centre"]');
        if(ddLlocCentre.length) {
            //Buscar els llocs de treball del treballador
            ddLlocCentre.empty().val('');
            $.post("/ajax/employee/getSkillworkplaces", {
                'employee_id': emp_id,
                'workplace_id': wp_id
            }, function (json) {
                $.each(json.skills, function (id, skill) {
                    ddLlocCentre.append($("<option>")
                        .val(id)
                        .html(skill)
                    );
                });
                modal.modal('show');
            });
        }else{
            modal.modal('show');
        }
    }else{
        modal.modal('show');
    }

    //Quan es tanca el modal s'ha de ressetejar el formulari
    modal.on('hidden.bs.modal', function () {
        modalForm.trigger("reset");
        var myDropzone = Dropzone.forElement("#dropzonejs");
        myDropzone.removeAllFiles(true);
    });
});

$(document).on("click", ".file-tree .make-folder > a", function(e){
    e.preventDefault();

    var tree = $(this).closest('li.file-tree-folder.master');
    $.magnificPopup.open({
        items: {
            src: '' +
                '<div class="white-popup">' +
                '   <form id="new-folder-form">' +
                '       <input type="hidden" name="code" value="'+tree.data('code')+'">' +
                '       <div class="form-group mb-1">' +
                '           <label for="folder">'+Lang.get('messages.folder_name')+'</label>' +
                '           <input type="text" id="folder" required class="form-control form-control-sm form-inline" placeholder="Carpeta" name="folder">' +
                '       </div>' +
                '       <button type="submit" class="btn btn-sm btn-primary">'+Lang.get('messages.create')+'</button>' +
                '   </form>' +
                '</div>',
            type: 'inline'
        },
        callbacks: {
            open: function() {
                window.setTimeout(function(){
                    $('#new-folder-form').find('input[type="text"]').focus();
                }, 100);
            }
        }
    });
});

$(document).on("submit", "#new-folder-form", function(e){
   e.preventDefault();

   var data = $(e.target).serializeArray();
   data.push({'name' : 'workplace_id', 'value' : $('#wp').val()});

    $.post("/ajax/procedures/folder/create", data, function (json) {
        if(json.success === true){
            $('ul.file-tree').find('li[data-code="'+json.code+'"] > ul').replaceWith(json.html);
            $.magnificPopup.close();
        }
    }, 'json');
});

$('#btnExternalCAE').click(function(e) {
    e.preventDefault();
    $('#caeModal').modal('show');
});

$('#btnDangerProduct').click(function(e) {
    e.preventDefault();
    $('#productModal').modal('show');
});

$('#btnSignInventory').click(function(e) {
    e.preventDefault();
    $('#signatureInventoryModal').modal('show');
})

$('#formCae').submit(function(e){
    //let treb = $(e.target).find('select[name="treballadors[]"]').val();
    let tipus = [];
    let message = '';
    let valid = true;

    $(e.target).find('input[name="tipus[]"]:checked').each(function(){
        tipus.push($(this).val());
    });

    /*if(treb.length < 1){
        $('#accordionCae').find('#collapseOne').collapse('show');
        $('#accordionCae').find('#collapseTwo').collapse('hide');
        message = 'Selecciona com a mínim un treballador';
        valid = false;
    }else */
    if(tipus.length < 1){
        message = 'Selecciona com a mínim una documentació';
        valid = false;
    }

    if(! valid){
        $.toast({
            text: message,
            icon: 'warning',
            position: 'bottom-right'
        });
        return false;
    }else{
        $(e.target).find('button[type="submit"]').prop('disabled', true);
        window.setTimeout(function (){
            $(e.target).find('button[type="submit"]').prop('disabled', false);
            $('#caeModal').modal('hide');
            $('#caeModal').find('input[type="checkbox"]').prop('checked', false);
            $('#caeModal').find('select option').prop('selected', false);
            $('#caeModal').find('select').selectpicker('refresh');
            $('#accordionCae').find('#collapseOne').collapse('show');
            $('#accordionCae').find('#collapseTwo').collapse('hide');
        }, 2000);

        $.toast({
            text: 'Revisa la descarga',
            icon: 'success',
            position: 'bottom-right'
        });
    }
});



function addDocument(code, model, model_name, model_id, document_id, path, description, date){
    var fileTree = $('ul.file-tree');
    var curChild;

    if(model){
        curChild = fileTree.find('li[data-'+model_name+'="'+model_id+'"]');
    }else{
        curChild = fileTree.find('li[data-code="'+code+'"]');
    }

    var node = $(''+
        '<li class="doc" onclick="event.stopPropagation()">\n' +
        '    <a href="'+path+'" class="btn-link text-dark">\n' +
        '      '+description+'\n' +
        '    </a>\n' +
        '    <span>'+date+'</span>\n' +
        '</li>\n');

    if(code === 20402){
        node.append('<span class="badge badge-info text-white ml-1">'+Lang.get('messages.pending_validation')+'</span>');
    }else if(code !== 20701){
        node.append('<a href="javascript:;" title="'+Lang.get('messages.delete')+'" data-document="'+document_id+'" class="deleteDoc btn-link text-gray">\n' +
                '        <i class="icon icon-trash"></i>\n' +
                '    </a>');
    }

    node.find('.deleteDoc').click(function(e){
        e.preventDefault();
        deleteDocument(document_id, e.target);
    });

    curChild.find('ul').append(node);
}

$('li.doc').on("click", "a.deleteDoc", function(e){
    e.preventDefault();
    var doc_id = $(this).data('document');
    deleteDocument(doc_id, e.target);
});

function resetDocsModalForm(){
    $('#docsModal').find('form')[0].reset();
    Dropzone.forElement("#dropzonejs").removeAllFiles(true);
}

function deleteDocument(document_id, sender){
    if(confirm(Lang.get('messages.delete_confirmation'))) {
        $.post("/ajax/documents/delete", {'document_id': document_id}, function (json) {
            if (json.success) {
                $(sender).closest('li').remove();
                $.toast({
                    text: Lang.get('messages.delete_confirmed'),
                    icon: 'success',
                    position: 'bottom-right'
                });
            } else {
                $.toast({
                    text: Lang.get('messages.delete_failed'),
                    icon: 'warning',
                    position: 'bottom-right'
                });
            }
        });
    }
    return false;
}

$('.custom-file-input').on('change', function() {
    let fileName = $(this).val().split('\\').pop();
    $(this).next('.custom-file-label').addClass("selected").html(fileName);
});
